module.exports = __webpack_public_path__ + "static/img/icon_myorder_yixuan.6e5b4e3c.svg";